import React, { useEffect, useState } from 'react';
import InfoDialog from '../../../shared/InfoDialog';
import CasinoDomainsTable from '../../CasinoDomainsTable';

export default function SelectDomainModal({ open, onClose, domains, saveDomains }) {
  const [tempDomain, setTempDomain] = useState([]);

  useEffect(() => {
    setTempDomain(domains);
  }, [domains, open]);

  return (
    <InfoDialog
      open={open}
      onClose={onClose}
      onSaveClick={() => {
        saveDomains(tempDomain);
        onClose();
      }}>
      <CasinoDomainsTable domains={tempDomain} setDomains={setTempDomain} isDeleteModal />
    </InfoDialog>
  );
}
